import { ArrowCounterClockwiseIcon, CheckSquareOffsetIcon, SparkleIcon } from '@phosphor-icons/react'

import { emotionTheme } from '@styles/theme'

import type { ReactNode } from 'react'
import type { WorkflowStatusCode } from './types'

const ORANGE_HOVER_COLOR = '#ED7D1C'

interface WorkflowStatusStyleProps {
  icon: ReactNode
  label: string
  color: string
  background: string
  hoverBackground: string
}

export const WORKFLOW_STATUS_CONFIG: Record<WorkflowStatusCode, WorkflowStatusStyleProps> = {
  released: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Liberada Envio',
    color: emotionTheme.colors.blue.dark,
    background: emotionTheme.colors.blue.head,
    hoverBackground: emotionTheme.colors.primary
  },
  in_progress: {
    icon: <SparkleIcon size={16} weight="fill" />,
    label: 'Em Andamento',
    color: emotionTheme.colors.yellow[500],
    background: emotionTheme.colors.yellow[100],
    hoverBackground: emotionTheme.colors.yellow[500]
  },
  returned_gu: {
    icon: <ArrowCounterClockwiseIcon size={16} weight="bold" />,
    label: 'Devolvida GU',
    color: emotionTheme.colors.red.color,
    background: emotionTheme.colors.red.background,
    hoverBackground: emotionTheme.colors.error.color
  },
  gce_validation: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Em Validação GCE',
    color: emotionTheme.colors.orange.color,
    background: emotionTheme.colors.orange.background,
    hoverBackground: ORANGE_HOVER_COLOR
  },
  returned_gce: {
    icon: <ArrowCounterClockwiseIcon size={16} weight="bold" />,
    label: 'Devolvida GCE',
    color: emotionTheme.colors.red.color,
    background: emotionTheme.colors.red.background,
    hoverBackground: emotionTheme.colors.error.color
  },
  go_validation: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Em Validação GO',
    color: emotionTheme.colors.orange.color,
    background: emotionTheme.colors.orange.background,
    hoverBackground: ORANGE_HOVER_COLOR
  },
  controller_validation: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Em Validação Controller',
    color: emotionTheme.colors.orange.color,
    background: emotionTheme.colors.orange.background,
    hoverBackground: ORANGE_HOVER_COLOR
  },
  returned_controller: {
    icon: <ArrowCounterClockwiseIcon size={16} weight="bold" />,
    label: 'Devolvida Controller',
    color: emotionTheme.colors.red.color,
    background: emotionTheme.colors.red.background,
    hoverBackground: emotionTheme.colors.error.color
  },
  director_validation: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Em Validação Diretoria',
    color: emotionTheme.colors.orange.color,
    background: emotionTheme.colors.orange.background,
    hoverBackground: ORANGE_HOVER_COLOR
  },
  head_finance_validation: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Em Validação H. Finanças',
    color: emotionTheme.colors.orange.color,
    background: emotionTheme.colors.orange.background,
    hoverBackground: ORANGE_HOVER_COLOR
  },
  returned_head_finance: {
    icon: <ArrowCounterClockwiseIcon size={16} weight="bold" />,
    label: 'Devolvida H. Finanças',
    color: emotionTheme.colors.red.color,
    background: emotionTheme.colors.red.background,
    hoverBackground: emotionTheme.colors.error.color
  },
  vp_approval: {
    icon: <CheckSquareOffsetIcon size={16} weight="fill" />,
    label: 'Em Aprovação VP',
    color: emotionTheme.colors.green.color,
    background: emotionTheme.colors.green.background,
    hoverBackground: emotionTheme.colors.green.light
  }
}

export const HIERARCHY_ORDER = ['GU_DESK', 'GCE_GO_DESK', 'CONTROLLER_DESK', 'EXECUTIVE_DESK']

export const HIERARCHY_TITLE: Record<string, string> = {
  GU_DESK: 'Na Mesa da GU',
  GCE_GO_DESK: 'Na Sua Mesa da GCE/GO',
  CONTROLLER_DESK: 'Na Mesa da Controladoria',
  EXECUTIVE_DESK: 'Na Mesa Executiva'
}
